import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import type { FunctionComponent } from "react";

import {
  useHandleSurveyFinished,
  useHomepageImpressionCount,
  useTypeformHiddenFields,
} from "~/components/app-bar/typeform-button/hooks";

import { homeTypeformAtom } from "./atoms";
import { HomepageTypeformId } from "./consts";
import { StyledPopupButton } from "./styles";

/**
 * reference document
 * https://github.com/Typeform/embed/blob/main/packages/embed/README.md#modal-windows-popup-slider-sidetab-popover
 */
type PopupButtonReference = {
  close: () => void;
  open: () => void;
  refresh: () => void;
  toggle: () => void;
  unmount: () => void;
};

export const HomeTypeformBackToOriginalScmpButton: FunctionComponent = () => {
  const router = useRouter();
  const pageType = router?.query?.pageType ?? "";
  const isHomepage = pageType === "homepage";
  useHomepageImpressionCount(isHomepage);

  const buttonReference = useRef<PopupButtonReference>(null);

  const homeTypeformState = useAtomValue(homeTypeformAtom);

  useEffect(() => {
    if (homeTypeformState?.isOpenTypeform) {
      buttonReference?.current?.open();
    }
  }, [homeTypeformState, buttonReference]);

  const hidden = useTypeformHiddenFields();

  const handleSurveyFinished = useHandleSurveyFinished();

  return (
    <StyledPopupButton
      hidden={hidden}
      id={HomepageTypeformId}
      iframeProps={{ title: "Homepage Q3FY24: PPM (PWA)" }}
      medium="snippet"
      opacity={100}
      ref={buttonReference}
      size={70}
      autoClose
      hideHeaders
      transitiveSearchParams
      onClose={handleSurveyFinished}
      onSubmit={handleSurveyFinished}
    >
      home page typeform survey
    </StyledPopupButton>
  );
};

HomeTypeformBackToOriginalScmpButton.displayName = "HomeTypeformBackToOriginalScmpButton";
